import { cn } from "@/lib/utils"
import Image from "@/components/Image";

export function JartilandLogo({ className }: { className?: string }) {
  return (
    // <!-- HINT: Logo principal de la web, usado en la cabecera. -->
    <Image
      src="https://i.imgur.com/S58moiC.png"
      alt="Jartiland Logo"
      width={40}
      height={40}
      className={cn("rounded-full", className)}
      data-ai-hint="logo"
    />
  )
}
